<template>
  <div>
    <template v-if="editSoaIndex === index && !soa.isAutoSoa">
      <DataPicker font-size="14"
                  :default-date="dateEdit"
                  @setDate="setSoaDate"
                  :table="true"/>
    </template>
    <template v-else>
      {{formatDate(soa.date)}}
    </template>
  </div>
</template>

<script>
import DataPicker from '@/components/Main/DataPicker/DataPicker'
import moment from 'moment'
export default {
  name: 'DateColumn',
  components: {DataPicker},
  props: ['dateEdit', 'index', 'editSoaIndex', 'soa'],
  methods: {
    setSoaDate (date) {
      this.$emit('setDate', date)
    },
    formatDate (date) {
      if (date) {
        return moment(date).format('DD-MMM-YY')
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../../sass/variables";
  @import "../../../../../../../../sass/mixins";
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/DateColumn.vue